import SortBox from "~/ui/sortbox";
import { node } from "~/util/dom";
import { _ } from "~/i18n";

type PLACES_SORT = "custom" | "alphabetical_asc" | "alphabetical_desc" | "time_asc" | "time_desc" | "length_asc" | "length_desc";
export const DRAG_AND_DROP_TYPE_ENABLE = "custom";

const SORT_OPTIONS: Array<{
	title: string;
	value: PLACES_SORT,
}> = [
	{
		title: "mymap.places.sort.custom",
		value: "custom",
	},
	{
		title: "mymap.places.sort.titleAZ",
		value: "alphabetical_asc",
	},
	{
		title: "mymap.places.sort.titleZA",
		value: "alphabetical_desc",
	},
	{
		title: "mymap.places.sort.sortDateDesc",
		value: "time_desc",
	},
	{
		title: "mymap.places.sort.sortDateAsc",
		value: "time_asc",
	},
	{
		title: "mymap.places.sort.sortLengthAsc",
		value: "length_asc",
	},
	{
		title: "mymap.places.sort.sortLengthDesc",
		value: "length_desc",
	},
];

export function buildSortSelectBox(cb?: (value) => void): {
	container: HTMLDivElement;
	sortBox: SortBox;
 } {
	const sortBox = new SortBox({
		options: SORT_OPTIONS,
		onSelect: value => {
			cb && cb(value);
		},
		//selectedIndex: SORT_OPTIONS.findIndex(option => option.value === this._orderValue),
	});
	const container = node("div", { className: "places-sort-cont" });

	container.append(_("mymap.places.sort.title"), sortBox.node);

	return {
		container,
		sortBox,
	};
}
